import type {components, paths} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';

export type ReceiptRequestBody = components['schemas']['Receipt'];

type CreateReceiptOperation = paths['/executor_web/receipts']['post'];

export type CreateReceiptRequest = NonNullable<
	NonNullable<CreateReceiptOperation['requestBody']>['content']['application/json']
>;

/** POST `/executor_web/receipts` — создать чек (ответ 200 без тела) */
export function createReceipt(request: CreateReceiptRequest, signal?: AbortSignal) {
	return axiosInstance.post<void>('receipts', request, {signal});
}
